export const getYouTubeId = (url: string) => {
    if (!url) return null
    const regex =
        /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/
    const match = url.match(regex)
    return match ? match[1] : null
}

export const getVideoThumbnail = (videoLink: string) => {
    const youtubeId = getYouTubeId(videoLink)
    if (youtubeId) {
        return `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`
    }
    return 'https://via.placeholder.com/640x360'
}